import 'react-h5-audio-player/src/styles.scss';
import './AudioPlayerModal.sass';

import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import AudioPlayer from 'react-h5-audio-player';

import {
  CHAPTER_AUDIO_PLAYLIST_ERROR,
  CHAPTER_AUDIO_PLAYLIST_SUCCESS,
} from '../../../components/Books/constants';

function AudioPlayerModal({ show, onHide, title, playlist, playlistState }) {
  const [currentAudioIdx, setCurrentAudioIdx] = useState(0);

  const handlePrevious = () => {
    if (playlistState === CHAPTER_AUDIO_PLAYLIST_SUCCESS) {
      setCurrentAudioIdx(
        currentAudioIdx > 0 ? currentAudioIdx - 1 : playlist.audios.length - 1,
      );
    }
  };
  const handleNext = () => {
    if (playlistState === CHAPTER_AUDIO_PLAYLIST_SUCCESS) {
      setCurrentAudioIdx(
        currentAudioIdx < playlist.audios.length - 1
          ? currentAudioIdx + 1
          : currentAudioIdx, // Avoid playing the playlist indefinitely
      );
    }
  };
  const handleOnEnd = () => {
    const DEFAULT_TIME_BETWEEN_AUDIOS_IN_MS = 1000;
    setTimeout(
      handleNext,
      playlist.timeBetweenQuestions * 1000 ?? DEFAULT_TIME_BETWEEN_AUDIOS_IN_MS,
    );
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="custom-audio-container">
        {Array.isArray(playlist?.audios) && playlist.audios.length > 0 && (
          <AudioPlayer
            src={
              playlistState === CHAPTER_AUDIO_PLAYLIST_ERROR
                ? ''
                : `${playlist.audios[currentAudioIdx].link}?t=${Date.now()}` // Add time param in request to avoid cached audios
            }
            showSkipControls
            showJumpControls={false}
            autoPlayAfterSrcChange
            customAdditionalControls={[
              <span key="audio-count" style={{ margin: '0 10px' }}>
                {`Audio ${currentAudioIdx + 1} of ${playlist.audios.length}`}
              </span>,
            ]}
            footer={
              <div style={{ textAlign: 'center' }}>
                {playlistState === CHAPTER_AUDIO_PLAYLIST_ERROR && (
                  <span>Error: couldn&apos;t fetch audios</span>
                )}
              </div>
            }
            onClickPrevious={handlePrevious}
            onClickNext={handleNext}
            onEnded={handleOnEnd}
          />
        )}
      </Modal.Body>
    </Modal>
  );
}

export default AudioPlayerModal;
